import { useMutation } from '@tanstack/react-query'

import { createSiteContact } from '@/features/site/endpoints/sites'
import type { SiteContact } from '@/features/site/types/site'

export type UseCreateSiteContactMutationResult = ReturnType<typeof useCreateSiteContactMutation>

export function useCreateSiteContactMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { siteUuid: string; location: string; contact: SiteContact }) =>
      createSiteContact({ siteUuid: variables.siteUuid, location: variables.location, contact: variables.contact }),
  })

  return {
    createSiteContact: mutateAsync,
    ...mutationResult,
  }
}
